<div class="modal-column" *ngIf="auth.isAuthenticated() && auth.userInfo">
    <div class="signup-left-content">
        <h3 class="join-edg-heading">Verifying identity</h3>
        <div class="signup-image"></div>
        <div class="signup-value-wrap">
            <div class="_18-plus-icon">
                <div>18+</div>
            </div>
        </div>
    </div>
    <div class="form-wrap" [class.verified]="verified" [class.declined]="verified === false">
      <ng-container *ngIf="verificationState == 'pending'">
        <h5>ID verification is in progress!</h5>
        <p class="sub-text">Verification may take up to 3 minutes. You can see the progress below.</p>
        <h1>00:{{ makeTime(timer / 60) }}:{{ makeTime(timer % 60) }}</h1>
        <p class="kyc-verification">Verifying your documents...</p>
        <a [routerLink]="['/', {outlets: {modal: null }}]" data-id="signup4-main-href">
          <app-form-button class="full-width primary">Go to games</app-form-button>
        </a>
      </ng-container>
      <ng-container *ngIf="verificationState == 'consider'">
        <h5>ID verification is in progress!</h5>
        <p class="sub-text">Your verification failed first check, but we will review it manually and came back to you soon!
          <br>Review may take up to 24 hours.</p>
        <a [routerLink]="['/', {outlets: {modal: null }}]" data-id="signup4-main-href">
          <app-form-button class="full-width primary">Go to games</app-form-button>
        </a>
      </ng-container>
      <ng-container *ngIf="verificationState == 'kyc'">
        <h5>Verification required!</h5>
        <p class="sub-text">Your verification failed, please try again!
          <br/>
          Check Your email to know the reason of why your documents were declined.</p>
        <a [routerLink]="['/', {outlets: {modal: 'signup-kyc' }}]" data-id="signup4-main-href">
          <app-form-button class="full-width primary">Refill identity form</app-form-button>
        </a>
      </ng-container>
      <ng-container *ngIf="verificationState == 'declined'">
        <h5>Verification declined!</h5>
        <p class="sub-text">Your verification failed, check Your email to know the reason of why your documents were declined.<br>
          If you thing there was an error, you can always contact our support.</p>
      </ng-container>
      <ng-container *ngIf="verificationState == 'verified'">
        <h5>Indentity verified!</h5>
        <p class="sub-text">Your verification completed successfully!</p>
        <a [routerLink]="['/', {outlets: {modal: 'withdraw' }}]" *ngIf="verified !== false" data-id="signup4-main-href">
          <app-form-button class="full-width" [class.primary]="verified">Go to withdraw</app-form-button>
        </a>
      </ng-container>
    </div>
    <a [routerLink]="['/', {outlets: { modal: null } } ]" class="icon close-popup" data-id="signup4-close-href">
        <i class="fal fa-times"></i>
    </a>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/signup/4/signup-modal.template.html